module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/long-arrow-left.svg?51014f2aad02f37d67e68d830e1394ca";